/**
 * Utility to generate a stable, consistent avatar color based on a string (e.g., patient name).
 */

const AVATAR_COLORS = [
    "bg-zen-teal/10 text-zen-teal",
    "bg-zen-blue/10 text-zen-blue",
    "bg-zen-indigo/10 text-zen-indigo",
    "bg-zen-purple/10 text-zen-purple",
    "bg-zen-pink/10 text-zen-pink",
];

/**
 * Returns a Tailwind color class pair (background and text) based on the hash of the input name.
 */
export const getAvatarColor = (name: string): string => {
    if (!name) return AVATAR_COLORS[0];

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
};

/**
 * Returns the initials for a given first and last name.
 */
export const getInitials = (firstName: string = "", lastName: string = ""): string => {
    const first = firstName?.charAt(0) || "";
    const last = lastName?.charAt(0) || "";
    return (first + last).toUpperCase() || "?";
};
